<template>
    <div class='spaceCenter common common-form-inline'>
        <a-form-model
        style="width:400px"
        ref="ruleForm"
        :model="pageData"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        >
            <a-form-model-item label="请输入新密保手机" prop="newMobile">
                <a-input v-model="pageData.newMobile"/>
            </a-form-model-item>
            <a-form-model-item label="请输入验证码" prop="newCode">
                <div class="input-box">
                    <a-input v-model="pageData.newCode"/>
                    <a-button @click="onFetchCode()" type="primary" :disabled="codeAble||countDisabled" size="small" class="input-btn">
                        <span v-show="counter>0">{{counter}}</span>{{countDisabled?"重新获取":"免费获取验证码"}}
                    </a-button>
                </div>
                <div class="text-size-12 text-color-red" style="position:absolute;white-space: nowrap;">{{errMsg}}</div>
            </a-form-model-item>
        </a-form-model>
    </div>
</template>

<script>
import {getUserInfo,getApproveInfoByAprvId,checkUser,getCaptcha,modifyMobile} from "@/api/security.js"
export default {
    name:"user-modify",
    data() {
        return {
            labelCol: { span: 9 },
            wrapperCol: { span: 15 },
            pageData:{
                newPswd:"",
                confirmPswd:""
            },
            rules:{
                newMobile:{
                    required: true,
                    trigger: "blur",
                    whitespace:true,
                    validator:(rule,value,cbfn) => {
                        const isMobile = this.pageData.newMobile.match(this.utils.regExpObj.MOBILE_PATTERN);
                        if (!value) {
                            this.codeAble = true;
                            cbfn('请输入新密保手机');
                        } 
                        else if(!isMobile){
                            this.codeAble = true;
                            cbfn('手机号码格式不正确');
                        }
                        else{
                            this.codeAble = false;
                            cbfn();
                        }
                    }
                },
                newCode:{
                    required: true,
                    trigger: "blur",
                    whitespace:true,
                    validator: (rule, value, cbfn) => {
                        if (!value) {
                            cbfn('请输入验证码');
                        } 
                        cbfn();
                    }
                }
            },
            codeAble:true,
            captchaType:'SMS',
            counter:0,
            countDisabled:false,
            errMsg:""
        };
    },
    computed: {},
    methods: {
        countTimmer(init){
            if(init) {
                this.countDisabled = true;
                this.counter = 60;
            }
            if(this.counter > 0){
                setTimeout(() => {
                    this.counter --;
                    this.countTimmer();
                },1000)
            }else{
                this.countDisabled = false;
            }
        },
        // 发送验证码
        onFetchCode() {
            const params = {
                target: this.pageData.newMobile
            };
            Object.assign(params, {
                mode: 'SMS',
                type: 'pwd'
            });
            getCaptcha(params).then(res => {
                this.countTimmer(true);
                this.$message.success("验证码发送成功");
            }).catch(err => {
                console.log(err);
            });
        },
        check(){
            return new Promise((resolve,reject) => {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        const params = {
                            jfCode: 'pwd',
                            ...this.pageData
                        };
                        modifyMobile(params,true).then(res => {
                            resolve(res);
                        }).catch(err => {
                            this.errMsg = err.description;
                            reject(err);
                        })
                
                    } else {
                        return false;
                    }
                });
            })   
        }

    },
    created() {
       
    },
    mounted() {},
    watch: {}
}
</script>
<style scoped>
.common-form-inline{
    margin: 40px 0;
}
.input-box{
    position: relative;
}
.input-btn{
    position: absolute;
    right: 5px;
    top: 8px;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/steps/mobile-modify.vue